import { useQuery } from "@tanstack/react-query";
import { ArchiveConfig } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const useSnapshotArchivingTypes = () => useQuery({
  queryKey: ["snapshotArchivingTypes"],
  queryFn: () => defaultOnError(
    ArchiveConfig.snapshotArchivingTypes(),
    "Loading snapshot archiving types failed with status",
    "Could not load snapshot archiving types."
  ),
  staleTime: 6e4
});
export default useSnapshotArchivingTypes;
